import { SectionHelperUniDriver } from '@wix/design-system/dist/testkit/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';

export function TableTopNotificationUniDriver(
  base: UniDriver,
  body: UniDriver,
) {
  const sectionHelper = SectionHelperUniDriver(base, body);
  return {
    wait: (timeout?: number) => base.wait(timeout),
    ...baseUniDriverFactory(base),
    clickClose: () => sectionHelper.clickClose(),
    textContent: () => sectionHelper.textContent(),
  };
}

export default TableTopNotificationUniDriver;
